// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectQuoteMessage } from './DirectQuoteMessage.js'
import { HistoryType } from '../../Utils/History/HistoryType.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
export let DirectInstrumentPricesMessage = function ()
{
    DirectQuoteMessage.call(this, DirectMessageCode.CODE_INSTRUMENT_PRICES)
    this.Type = HistoryType.QUOTE_INSTRUMENT_PRICES
    this.IndicativeAuctionPrice = null
    this.IndicativeAuctionVolume = null
    this.LastTradedTime = null
    this.AvgTradedPrice = null
    this.TotalBuyQuantity = null
    this.TotalSellQuantity = null
    this.AuctionNumber = null
    this.AuctionStatus = null
    this.InitiatorType = null
    this.InitiatorPrice = null
    this.InitiatorQuantity = null
    this.HighOpenInterest = null
    this.LowOpenInterest = null
    // #73350
    this.TradedValue = null
    this.OffExchangeVolume = null
    this.OffExchangeValue = null
    // ------
    this.AuctionEndTime = null
    this.RemainingQty = null
    this.RemainingQtySide = null
    // #113099
    this.LPPHigh = null
    this.LPPLow = null

    this.FundingRateValue = null;
    this.MarkPrice = null;
    this.NextFundingTimeUTC = null;
}

DirectInstrumentPricesMessage.prototype = Object.create(DirectQuoteMessage.prototype)